import { dbReducer, ReduxFind, insert, removeMany } from '@weblite/persist'
import { PendingEdit } from './types'

const COLLECTION = 'pendingEdits'

export const pendingEditsStorage = {
  getAll(): PendingEdit[] {
    return ReduxFind(COLLECTION, {})
  },

  deleteMany(ids: string[]) {
    return removeMany(COLLECTION)(ids)
  },

  insert(messages: PendingEdit[]) {
    insert(COLLECTION)(messages)
  },
}

export const pendingEditsReducer = dbReducer(['main', COLLECTION])
